import { Routes, Route } from "react-router-dom";
import { User } from "@supabase/supabase-js";
import { 
  AdminStats,
  AdminTools,
  AdminUsers,
  AdminPayments,
  AdminTickets,
  AdminBillboards,
  AdminGroups,
  AdminMunicipalities,
  CreateEvent,
  EditEvents,
  LazyWrapper
} from "@/components/lazy/LazyRoutes";
import AdminRoute from "./AdminRoute";

interface AdminRoutesProps {
  user: User | null;
}

const AdminRoutes = ({ user }: AdminRoutesProps) => {
  return (
    <Routes>
      <Route path="stats" element={<AdminRoute><LazyWrapper><AdminStats /></LazyWrapper></AdminRoute>} />
      <Route path="tools" element={<AdminRoute><LazyWrapper><AdminTools /></LazyWrapper></AdminRoute>} />
      <Route path="users" element={<AdminRoute><LazyWrapper><AdminUsers /></LazyWrapper></AdminRoute>} />
      <Route path="groups" element={<AdminRoute><LazyWrapper><AdminGroups /></LazyWrapper></AdminRoute>} />
      <Route path="municipalities" element={<AdminRoute><LazyWrapper><AdminMunicipalities /></LazyWrapper></AdminRoute>} />
      <Route path="payments" element={<AdminRoute><LazyWrapper><AdminPayments /></LazyWrapper></AdminRoute>} />
      <Route path="tickets" element={<AdminRoute><LazyWrapper><AdminTickets /></LazyWrapper></AdminRoute>} />
      <Route path="billboards" element={<AdminRoute><LazyWrapper><AdminBillboards /></LazyWrapper></AdminRoute>} />
      <Route path="create-event" element={<AdminRoute><LazyWrapper><CreateEvent /></LazyWrapper></AdminRoute>} />
      <Route path="edit-events" element={<AdminRoute><LazyWrapper><EditEvents /></LazyWrapper></AdminRoute>} />
    </Routes>
  );
};

export default AdminRoutes;